<template>
  <div class="eventNewCrudComp">

    <div class="div_img">
      <!-- <label class="label_title" for="">Изображение</label> -->
      <label-hint-comp
          :textLabel="`Изображение`"
          :textHint="'Формат: jpg, png; размер не больше 6Мб; соотношение строн 16:9'"
          :showBtn="true"
      />
      <image-upload-comp
          :setImgProp="setImage"
          :class="[{'animated shake error_input': errors.image}]"
      ></image-upload-comp>
      <p class="p_err_min">{{ errors.image }}</p>
    </div>

    <div>
      <label class="label_title" for="">Название</label>
      <input
          type="text"
          v-model="name"
          :class="['input_grey', {'animated shake error_input': errors.name}]"
          @click="resetError('name')"
      >
      <p class="p_err_min">{{ errors.name }}</p>
    </div>

    <div>
      <label-hint-comp
          :textLabel="`Описание ( ${maxInfo - (info ? info.length : 0 )} /  ${maxInfo} )`"
          :showBtn="false"
      />
      <textarea
          v-model="info "
          :maxlength="maxInfo"
          cols="10"
          rows="10"
          type="text"
          @click="resetError('info')"
          :class="['textarea_grey_1',{'animated shake error_input': errors.info}]">
      </textarea>
      <p class="p_err_min">{{ errors.info }}</p>
    </div>

    <div>
      <div class="div_check">
        <input type="checkbox" :id="`checkbox_isActive`" v-model="isActive">
        <label :for="`checkbox_isActive`" class="check_title">Активна</label>
      </div>
    </div>

    <div>
      <label class="label_title" for="">Дата завершения</label>
      <date-picker-one-comp ref="endDate" :disabled="false"/>
      <p class="p_err_min"></p>
    </div>

    <div class="div_btns">
      <button-comp :classBtn="'btn_orange_min'" :textBtn="'Сохранить'" :clickBtn="save"/>
      <button-comp :classBtn="'btn_orange_min'" :textBtn="'Назад'" :clickBtn="toAll"/>
    </div>

    <p class="p_err_main">{{ errMain }}</p>

  </div>
</template>

<script>
// import UploadImage from 'vue-upload-image';

export default {
  name: 'eventNewCrudComp',
  props: {},
  data: function () {
    return {
      required: null,
      moduleName: 'events',
      isActive: true,
      name: '',
      info: '',
      maxInfo: 250,
      image: null
    }
  },
  beforeCreate: function () {
  },
  created: function () {
  },
  watch: {},
  components: {},
  computed: {
    errMain: function () {
      return this.$store.getters[`${this.moduleName}/getErrMain`]
    },
    errors: function () {
      return this.$store.getters[`${this.moduleName}/getErrors`]
    },
    role: function () {
      return localStorage.getItem('role')
    },
    problems: function () {
      return this.$store.getters[`${this.moduleName}/getProblems`]
    }
  },
  methods: {
    setImage (image) {
      this.image = image
      this.resetError('image')
    },
    save () {
      // let endDate = null
      //
      let d = {
        name: this.name,
        info: this.info,
        image: this.image,
        isActive: this.isActive
      }
      if (this.$refs.endDate.time) d.endDate = this.$refs.endDate.time
      // let endDate = new Date(this.$refs.endDate.time);
      this.$store.dispatch(`${this.moduleName}/add`, d)
    },
    toAll () {
      this.$store.dispatch(`${this.moduleName}/toAll`)
    },
    resetError (param) {
      this.$store.commit(`${this.moduleName}/setErrors`, { param: param, value: null })
    }
  }
}
</script>

<style scoped lang="scss">
.eventNewCrudComp {
  width: 350px;
  margin: 32px auto 32px auto;
}

.div_btns {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 32px;
  margin-top: 32px;
}

.div_img {
  display: grid;
  grid-template-rows: 2fr;
  grid-template-columns: 1fr;
}

.div_img > label {
  text-align: left;
}

.div_check {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 60px 1fr;
  margin-bottom: 20px;
}

.div_check input {
  margin: auto 10px auto auto;
}

.div_check label {
  margin: auto;
}

@media screen and (max-width: 1140px) {
}

@media screen and (max-width: 960px) {
}

@media screen and (max-width: 720px) {
}

@media screen and (max-width: 540px) {
}

@media screen and (max-width: 480px) {
  .ticketNewCrudComp {
    width: calc(100% - 32px);
  }
}

@media screen and (max-width: 320px) {
}

</style>
